import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { CommandResult } from "../../../../shared/_types/command-result.type";
import { TradingSymbolsList } from "../../../../shared/_types/trading-symbols-list.type";

@Injectable({
    providedIn: "root",
})
export class TradingSymbolsListsService {
    constructor(private http: HttpClient) {}

    list(): Observable<TradingSymbolsListView[]> {
        return this.http.get<TradingSymbolsListView[]>("/trading-symbols-lists");
    }

    get(id: string): Observable<TradingSymbolsList> {
        return this.http.get<TradingSymbolsList>(`/trading-symbols-lists/${id}`);
    }

    delete(id: string): Observable<CommandResult> {
        return this.http.delete<CommandResult>(`/trading-symbols-lists/${id}`);
    }

    create(list: TradingSymbolsList): Observable<CommandResult> {
        return this.http.post<CommandResult>("/trading-symbols-lists", list);
    }

    update(id: string, list: TradingSymbolsList): Observable<CommandResult> {
        return this.http.patch<CommandResult>(`/trading-symbols-lists/${id}`, list);
    }

    updateFromFile(id: string, file: File): Observable<CommandResult> {
        const formData = new FormData();
        formData.append("file", file);
        return this.http.patch<CommandResult>(`/trading-symbols-lists/${id}/file`, formData);
    }
}

export type TradingSymbolsListView = {
    id: string;
    name: string;
};
